import { withBase } from "@/lib/tenant-slug";
import { Link, useLocation } from "wouter";
import { AlertTriangle } from "lucide-react";
import htLogoFull from "@assets/HTCAPITAL_logo-01_trimmed.png";

export function LandingFooter() {
  const [location] = useLocation();

  const scrollToSection = (anchor: string) => {
    if (location !== "/") {
      window.location.href = withBase("/") + anchor;
      return;
    }
    const element = document.querySelector(anchor);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <footer className="bg-[#080814] border-t border-white/5">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div className="space-y-4">
            <div className="flex items-center">
              <img src={htLogoFull} alt="HT Capital" className="h-6 w-auto" data-testid="img-logo-footer" />
            </div>
            <p className="text-sm text-gray-400">
              Mesa Proprietária Institucional
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-white">Institucional</h4>
            <nav className="flex flex-col gap-2">
              <button
                onClick={() => scrollToSection("#estrutura")}
                className="text-left text-sm text-gray-400 hover:text-white transition-colors"
              >
                Estrutura
              </button>
              <button
                onClick={() => scrollToSection("#modelo-operacional")}
                className="text-left text-sm text-gray-400 hover:text-white transition-colors"
              >
                Modelo Operacional
              </button>
              <button
                onClick={() => scrollToSection("#fases")}
                className="text-left text-sm text-gray-400 hover:text-white transition-colors"
              >
                Fases
              </button>
              <button
                onClick={() => scrollToSection("#sobre")}
                className="text-left text-sm text-gray-400 hover:text-white transition-colors"
              >
                Sobre
              </button>
            </nav>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-white">Operador</h4>
            <nav className="flex flex-col gap-2">
              <Link href="/">
                <span className="text-sm text-gray-400 hover:text-white cursor-pointer transition-colors">Login</span>
              </Link>
              <Link href="/processo-seletivo">
                <span className="text-sm text-gray-400 hover:text-white cursor-pointer transition-colors">Solicitar Avaliação</span>
              </Link>
            </nav>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-white">Contato</h4>
            <p className="text-sm text-gray-400">
              contato@hightrading.com.br
            </p>
          </div>
        </div>

        <div className="border-t border-white/5 pt-8">
          <div className="flex items-start gap-3 p-4 rounded-lg bg-yellow-500/5 border border-yellow-500/20 mb-6">
            <AlertTriangle className="h-5 w-5 text-yellow-500 flex-shrink-0 mt-0.5" />
            <div className="text-sm text-gray-400">
              <p className="font-medium text-white mb-1">Aviso Institucional</p>
              <p>
                Operar mercados financeiros envolve riscos substanciais, incluindo a possibilidade de perda total de capital. 
                A HT CAPITAL não oferece promessa de retorno, garantia de resultado ou qualquer forma de recomendação de investimento. 
                O foco da estrutura é processo, governança e controle de risco.
              </p>
            </div>
          </div>

          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-500">
            <p>&copy; {new Date().getFullYear()} High Trading LTDA - 29.247.536/0001-98. Todos os direitos reservados.</p>
            <div className="flex gap-4">
              <Link href="/termos">
                <span className="hover:text-primary cursor-pointer transition-colors">Termos de Uso</span>
              </Link>
              <Link href="/privacidade">
                <span className="hover:text-primary cursor-pointer transition-colors">Privacidade</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
